import React, { Component } from 'react';
import { Table } from 'react-bootstrap';
import ApiService from '../../service/ApiService';
import { Link } from 'react-router-dom';

class Loosers extends Component {
    constructor(props) {
        super(props);
        this.state = {
            looserList: []
        };
    }

    componentDidMount() {

        ApiService.getLoosers()
            .then(result => {
                console.log('Loosers', result);
                let filteredData = [];
                for (var i = 0; i < 10; i++) {
                    filteredData.push(result[i]);
                }
                this.setState({ looserList: filteredData });
            })
            .catch((error) => {
                console.log(error);
            });

    }

    renderRowLooser(listValue) {
        if (listValue !== undefined && listValue.ticker !== undefined) {
            let url = '/chart/' + listValue.ticker;
            return (
                <tr style={{ color: 'red' }} key={listValue.ticker}>
                    {/* <td><a style={{ color: 'red' }} href={url}>{listValue.ticker}</a></td> */}
                    <td style={{ color: 'red' }}><Link to={url}>{listValue.ticker}</Link></td>
                    <td>{parseFloat(listValue.price).toFixed(2)}</td>
                    <td>{parseFloat(listValue.changesPercentage).toFixed(2)}%</td>
                    <td><Link style={{ color: 'red' }} to={'/stocks/loosers'}>Top Loosers</Link></td>
                </tr>
            )
        }
    }

    render() {
        let looserRow;

        if (this.state.looserList === undefined || this.state.looserList.length <= 0) {
            looserRow = <tr><td></td><td>No Data</td><td></td></tr>
        } else {
            looserRow = this.state.looserList.map(this.renderRowLooser.bind(this));
        }

        return (
            <Table bordered hover size="xs" style={{ fontSize: "10px" }}>
                <thead>
                    <tr>
                        <th>Ticker</th>
                        <th>Last</th>
                        <th>Change</th>
                        <th><Link to={'/stocks/loosers'}>Top Loosers</Link></th>
                    </tr>
                </thead>
                <tbody>
                    {looserRow}
                </tbody>
            </Table>
        );
    }
}

export default Loosers;
